import React from 'react';
import { PropTypes } from 'prop-types';
import { Icon } from 'components/project/ClerkScreen';
import {
  Container, ItemNumber, UserInfo, Timestamp, ReplyTo,
} from './Styles';

const MetaData = ({
  itemNumber,
  timestamp,
  onReplyClick,
  handleMetaDataClick,
}) => (
  <Container>
    {itemNumber && (
      <ItemNumber
        onClick={() => handleMetaDataClick('itemNumber', itemNumber)}
      >
        {itemNumber !== 'No item' && (
        <>
          <Icon icon="info" size={1} />
          {itemNumber}
        </>
        )}
      </ItemNumber>
    )}
    <UserInfo />
    {timestamp && (
      <Timestamp>
        <Icon icon="clock-o" size={1} />
        {timestamp}
      </Timestamp>
    )}
    {onReplyClick && (
      <ReplyTo onClick={onReplyClick}>
        <Icon icon="reply" size={1} />
        Reply
      </ReplyTo>
    )}
  </Container>
);


MetaData.propTypes = {
  itemNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  timestamp: PropTypes.string,
  onReplyClick: PropTypes.func,
  handleMetaDataClick: PropTypes.func.isRequired,
};

MetaData.defaultProps = {
  itemNumber: null,
  timestamp: null,
  onReplyClick: null,
};

export default MetaData;
